import React from 'react'

import s from './Confirmation.module.scss'
import SerialTicketsConfirmation from './SerialTicketsConfirmation/SerialTicketsConfirmation'
import TermsAndConditions from './TermsAndConditions/TermsAndConditions'

export default function Confirmation() {
  return (
    <div className={s.confirmation}>
      <section>
        <SerialTicketsConfirmation />
      </section>
      <section>
        <TermsAndConditions />
      </section>
    </div>
  )
}
